module.exports = __webpack_public_path__ + "img/1_Archive_min.4cdf0504.jpg";